import styled from 'styled-components';

interface ITooltipButtonStyles {
    color?: string;
    bottom?: string;
    left?: string;
    width?: string;
}


export const TooltipArea = styled.div`
    position: relative;

    width: auto;
    height: auto;
    padding:none;

`

export const Tooltip = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    position: absolute;
    left: ${({ left }: ITooltipButtonStyles) => left ? left : "-50%"};;
    bottom: ${({ bottom }: ITooltipButtonStyles) => bottom ? bottom : "52%"};
    white-space: pre-wrap;
    z-index: 20;
    color: ${({ color }: ITooltipButtonStyles) => color ? color : "#293E52"};
    width: ${({ width }: ITooltipButtonStyles) => width ? width : "162px"};
    height: auto;
    padding: 16px;
    background-color: #FFF;
    box-sizing: border-box;
    box-shadow: 0px 4px 23px rgba(0, 0, 0, 0.1);

    font-size: 12px;
    line-height: 14px;
    letter-spacing: -0.015em;
    text-align: center;
    user-select: none;
    border-radius: 8px;
`